import script from "./SecuritySectionTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./SecuritySectionTitle.vue?vue&type=script&setup=true&lang=js"

import "./SecuritySectionTitle.vue?vue&type=style&index=0&id=26e8ddd6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26e8ddd6"]])

export default __exports__